import "../../styles/components/shareProfileSheet/shareProfileSheet.scss";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";
import Modal from "react-bootstrap/Modal";
import { useAppSelector } from "../../store/hooks";
import { selectUser } from "../../store/features/user";
import QRCode from "react-qr-code";
import CopyToClipboard from "react-copy-to-clipboard";
import { Translate, withLocalize } from "react-localize-redux";
import translations from "../../translations/welcomeSheet.json";
import styled from "styled-components";
import Notification from "../../components/notification/Notification";
import { ReactComponent as CopyIcon } from "../../assets/images/icons/copy-icon.svg";
import { ReactComponent as DownloadQrIcon } from "../../assets/images/icons/download-qr-icon.svg";
import { ReactComponent as CloseIcon } from "../../assets/common/close-icon.svg";
import { useLayoutEffect } from "react";

const StyledShareSheetWeb = styled.div`
	${(props) => `
	width: 100%;
    .customizable-text {
      color: ${props.textColor} !important;
    }
	.customizable-icon {
		fill: ${props.primaryColor} !important;
		stroke: ${props.primaryColor} !important;
	}
	.active {
		.customizable-icon {
			fill: #fff !important;
		}
	}
  `};
`;

function ShareProfileSheet(props) {
	useLayoutEffect(() => {
		props.addTranslation(translations);
	}, []);

	const downloadQR = () => {
		const svg = document.getElementById("qr-code");
		const svgString = new XMLSerializer().serializeToString(svg);
		let blob = new Blob([svgString], { type: "image/svg+xml" });
		const canvas = document.createElement("canvas");
		let url = URL.createObjectURL(blob);
		const ctx = canvas.getContext("2d");
		canvas.width = svg.clientWidth;
		canvas.height = svg.clientHeight;
		const img = new Image();
		img.src = url;

		img.onload = () => {
			ctx?.drawImage(img, 0, 0);
			const downloadLink = document.createElement("a");
			downloadLink.href = canvas.toDataURL();
			downloadLink.setAttribute(
				"download",
				`profile-${userMeta.user.username}-qr.png`
			);
			downloadLink.setAttribute("target", `_blank`);
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		};
	};

	const config = getMasterConfig();
	const userMeta = useAppSelector(selectUser);

	return (
		<Modal
			show={props.sheetOpen}
			onHide={props.onClose}
			animation={false}
			centered
			dialogClassName="share-profile-sheet"
			backdropClassName="header-modal-backdrop"
		>
			<Modal.Header>
				<Modal.Title
					className="share-text"
					style={{
						marginTop: "15px",
						marginBottom: "30px",
					}}
				>
					<Translate
						id="shareDetailedText"
						data={{
							organizationName: config.organizationName,
						}}
					/>
				</Modal.Title>
				<CloseIcon className="close-icon" onClick={props.onClose} />
			</Modal.Header>

			<Modal.Body className="flex-column ai-c">
				<StyledShareSheetWeb
					primaryColor={config.primaryColor}
					textColor={config.primaryColor}
				>
					<div className="link-wrapper flex-column">
						<span className="container-title">
							<Translate id="profileLink" />
						</span>
						<div
							className={`gray-wrapper-link-${
								props.isMobile ? "mobile" : "web"
							} flex-row jc-sb`}
						>
							<a
								className="link-text customizable-text"
								href={`${window.location.origin}/${
									props.activeLanguage?.code ?? "en"
								}/profile/${userMeta.user.username}`}
								target="_blank"
								rel="noreferrer"
							>
								{`${window.location.origin}/${
									props.activeLanguage?.code ?? "en"
								}/profile/${userMeta.user.username}`}
							</a>

							<CopyToClipboard
								text={`${window.location.origin}/${
									props.activeLanguage?.code ?? "en"
								}/profile/${userMeta.user.username}`}
								onCopy={() => {
									Notification({
										type: "success",
										text: props.translate("copiedToClipboard").toString(),
									});
								}}
							>
								<CopyIcon className="link-icon customizable-icon" />
							</CopyToClipboard>
						</div>
					</div>
					<div className="qr-wrapper flex-column ai-c">
						<span className="container-title">
							<Translate id="shareViaQrCode" />
						</span>
						<div className="gray-wrapper-qr flex-row jc-c">
							<QRCode
								id="qr-code"
								size={props.isMobile ? 133 : 140}
								value={`${window.location.origin}/${
									props.activeLanguage?.code ?? "en"
								}/profile/${userMeta.user.username}`}
								viewBox={props.isMobile ? `0 0 133 133` : `0 0 140 140`}
							/>
							<DownloadQrIcon
								className="share-icon customizable-icon"
								onClick={downloadQR}
							/>
						</div>
					</div>
				</StyledShareSheetWeb>
			</Modal.Body>
		</Modal>
	);
}

export default withLocalize(ShareProfileSheet);
